import { notification } from 'antd';

/**
*	通知提醒栏
*	@params type值'success','info','warning','error'
*/
export default (type, message, description) => {
  notification[type]({
    message,
    description,
  });
};


// WEBPACK FOOTER //
// ./src/util/notice.js